import React from "react";

// components
import PageHeader from "../../../PageHeader/PageHeader";
import PageInfo from "../../components/PageInfo.js";
import ContactInfo from "../../components/ContactInfo.js";
import ImageGallery from "../../components/ImageGallery.js";
import PageState from "../../components/PageState.js";
// styles
import styles from "./Unge.module.css";

export default function Unge() {
    return(
        <PageState
            pageName="Unge"
            render={({ data, sections, sectionNames }) => {

                const { Sec1, Sec2, solagratia, u5, PageHeader: PageHeaderContent, Gallery } = data;

                return (
                    <div>
                        <PageHeader 
                            image={PageHeaderContent.imageUrl} 
                            title={PageHeaderContent.title} 
                            sections={sections} 
                            description={PageHeaderContent.text} 
                            sectionNames={sectionNames} 
                        />

                        <section className={styles.sec1} id={Sec1.secId}>
                            <PageInfo 
                                image={""} 
                                title={Sec1.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }} />} 
                                version="v1" 
                            />
                            <ContactInfo 
                                when={Sec1.when} 
                                where={Sec1.where} 
                                mobile={Sec1.mobile} 
                                who={Sec1.who} 
                            />
                        </section>
                        <section className={styles.gallery}>
                            <ImageGallery images={Gallery.images}/>
                        </section>

                        <section className={styles.sec2} id={Sec2.secId}>
                            <PageInfo 
                                image={""} 
                                title={Sec2.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec2.text }} />} 
                                version="v5" 
                            />
                            <ContactInfo 
                                when={Sec2.when} 
                                where={Sec2.where} 
                                mobile={Sec2.mobile} 
                                who={Sec2.who} 
                            />
                        </section>
                        
                        {solagratia && 
                        <section className={styles.sec1} id={solagratia.secId}>
                            <PageInfo 
                                image={""} 
                                title={solagratia.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: solagratia.text }} />} 
                                version="v1" 
                            />
                        </section>}
                        {u5 &&(<section 
                            id ={u5.secId} 
                            className={styles.sec2}>

                            <PageInfo 
                                title={u5.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: u5.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {u5.where} 
                                when={u5.when} 
                                who={u5.who} 
                                mobile={u5.mobile}
                                email={u5.email}/>
                        </section>)}
                    </div>
                );
            }
        }/>
    );
}
